<template>
    <div id="workLoadList">
      <div class="scrollTop" @click="toTop" v-show="toTopIsShow"><img src="../../assets/imgs/home/totop.png" alt=""></div>
      <div class="workload-body withgray">
       <div class="box">
         <el-row class="box-filter">
            <el-col :span="12" style="text-align: center;">
             <el-cascader size="mini" ref="cas_region" style="width:90% !important" :show-all-levels="false" change-on-select clearable :options="regionCascaders" @change="onSelectedRegion" v-model="regionIds" placeholder="请选择-默认全国" class="fixwidth"></el-cascader>
          </el-col>
          <el-col :span="12" style="text-align: center;">
             <el-select placeholder="请选择渠道" size="mini" style="width:90% !important" v-model="queryParams.channelId" @change="onSelectedChannel" clearable collapse-tags>
               <el-option size="mini" v-for="s in channelOptions" :key="s.Key" :label="s.Name" :value="s.Key"></el-option>
             </el-select>
           </el-col>
         </el-row>
         <el-row class="box-filter">
           <el-col :span="12" style="text-align: center;">
             <el-select placeholder="请选择岗位" size="mini" v-model="queryParams.roleId" @change="onSelectedRole" style="width:90% !important">
                <el-option :key="1" label="总部" :value="1"></el-option>
                <el-option :key="2" label="业务" :value="2"></el-option>
              </el-select>
            </el-col>
           <el-col :span="12" style="text-align: center;">
             <el-date-picker v-model="queryParams.sMonth" size="mini" style="width:90% !important" type="month" :editable="false" :clearable="false" placeholder="选择月" @change="onSelectedMonth"></el-date-picker>
           </el-col>
         </el-row>
      </div>  
       <div class="box withwhite">
          <div class="box-tab">
            <div class="box-tab-item" @click="changeTab('Region')" v-bind:class="{ 'box-tab-item-active': this.teamTab=='Region'}">区域</div><div class="box-tab-item" @click="changeTab('Channel')" v-bind:class="{ 'box-tab-item-active': this.teamTab=='Channel'}">渠道</div>
          </div>
       </div>
       <div class="box withgray box-target" v-loading="loadings.chartLoading">
          <el-row>
              <el-col :span="8">总店数:<h1 class="box-target-value">{{this.targetDatas.visitNum}}</h1></el-col>
              <el-col :span="8">本月有拜访:<h1 class="box-target-value">{{this.targetDatas.userNum}}</h1></el-col>
              <el-col :span="8">覆盖率:<h1 class="box-target-value">{{this.targetDatas.avgNum}}</h1></el-col>
          </el-row>
       </div>
       <div class="box withgray" style="height:430px">
         <div v-if="showBack" @click="goBack" class="chart-goback">返回</div>
          <div class="chartnew" v-loading="loadings.chartLoading">
              <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
              <div id="main" style="width: 98%;height:400px;"></div>
          </div>
       </div>
       <div class="box withgray box-kpi" v-loading="loadings.kpiLoading">
          <h2 class="box-target-value">KPI</h2>
          <div class="box withgray box-kpi-row-border" v-for="(value, key) in kpiGroups" :key="key">
            <h3 class="box-target-value pull-left">{{value}}</h3>
            <div class="box-kpi-row">
              <el-row style="margin-top: 10px">
                <el-col :span="8" v-for="(value, key) in itemGroups(value)" :key="key">{{value.ItemName}}:<br><div class="box-kpi-value">{{value.ItemValue}}</div></el-col>
              </el-row>
              
            </div>
          </div>
       </div>
     
      </div>
    </div>
  </template>
  <script>
  import { message,imgServerHost, getBaseUrl,getKPIRegionCascaderOption,getKPIRoleOption,getKPIChannelOption,GetToTerminalReport,GetToTerminalReport_KPI,getWorkRoleByUser} from "../../api/api";
  import libs from "../../utils/libs";
  import moment from "moment";
  import store from "../../utils/storage";
  import echarts from 'echarts';
  
  const animationDuration = 6000

  export default {
    data() {
      return {
        uid:0,
        teamTab:'Region',
        title:'',
        showFilter:false,
        searchLoading:false,
        showBack:false,
        imgHost:getBaseUrl(),
        loadings: {
          loading: false,
          chartLoading: false,
          tableLoading: false,
          importLoading: false,
          kpiLoading:false
        },
        curUser:{},
        targetDatas:{
          visitNum:0,
          userNum:0,
          avgNum:0
        },
        toTopIsShow:false,//控制回到顶部按钮是否显示
        kpiDatas:[],
        kpiGroups:[],
        roles: [],
        regionCascaders:[],
        regionIds:[],
        //channelIds:[],
        channelOptions: [],
        curParentRegion:{},
        curRegion:{},
        queryParams:{
          sDate:moment().format("YYYY-MM-DD"),
          eDate:moment().format("YYYY-MM-DD"),
          roleId: 1,
          regionId:'',
          channelId:'',
          userId:1,
          sMonth:moment().format("YYYY-MM"),
          reportType:1,
          sWhere:''
        },
        tableDatas:[],
        chartTitle:'',
        legendData:[],
        xAxisData:[],
        seriesData:[],
        dimensionsData:[],


      };
    },
    mounted() {
      this.uid=this.$route.params.uid;
      this.queryParams.userId=this.$route.params.uid;
      this.getRegionCascader();
      this.subChannelOption();
      //this.getRoles();
      //this.GetWorkRoleByUser();
      //console.log(this.teamTab);
      //this.getRegionCascader();
      //console.log(this.regionCascaders);
       //this.type=this.$route.params.type;
       this.chartTitle="";
       this.search();
       //console.log(this.regionCascaders);
       
       
    },
    created(){
            var _this=this;
            window.onscroll=function () {
                //鼠标滚轮滚动距离超过10像素时，回到顶部按钮才显示
                let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
                if(top>30){
                    _this.toTopIsShow=true;
                }else{
                    _this.toTopIsShow=false;
                }
            }
        },
    methods: {
      toBack(){
        //history.back();
        this.showBack=false;
        this.search();
      },
      itemGroups:function(value){
        var itemArr=[];
        for(var i=0;i<this.kpiDatas.length;i++){ 
              if(this.kpiDatas[i].GroupName===value){
                itemArr.push(this.kpiDatas[i]);
              }
          }
          //console.log(itemArr);
          return itemArr;
      },
      getRandIcon(){
        //return '../../assets/imgs/home/'+value+'.png';
        return '../../assets/imgs/home/1.png';
      },
      subChannelOption() {
        getKPIChannelOption(1).then(res => {
          if (res.data.Code != 1) return;
          this.channelOptions = res.data.Data;
          
        });
      },
      
      getRegionCascader() {
        getKPIRegionCascaderOption(1).then(res => {
          if (res.data.Code != 1) return;
          var arr=[];
          arr=res.data.Data[0].children;//去掉第一层全国
          //arr = this.filter(res.data.Data,3)[0].children;//去掉level=3及以下数据
          //去掉第一层全国，并且重置全国下面的parentKey
          for(var i=0;i<arr.length;i++){ //去掉最后一层
               arr[i].parentKey=null;
               var child=[];
               if(arr[i].children && arr[i].children.length){
                 child=arr[i].children;
                 for(var j=0;j<child.length;j++){
                   child[j].children=null;
                 }
               }
               this.regionCascaders.push(arr[i]) ;
          }
          // if (res.data.Code != 1) return;
          // var arr=[];
          // console.log(res.data);
          // //this.regionCascaders=res.data.Data;
          
          // //arr=res.data.Data[0].children;//去掉第一层全国
          // arr=res.data.Data;//去掉第一层全国
          // //arr = this.filter(res.data.Data,3)[0].children;//去掉level=3及以下数据
          // //去掉第一层全国，并且重置全国下面的parentKey
          // for(var i=0;i<arr.length;i++){ //去掉最后一层
          //      arr[i].parentKey=null;
          //      var child=[];
          //      if(arr[i].children && arr[i].children.length){
          //        child=arr[i].children;
          //        for(var j=0;j<child.length;j++){
          //          var child2=[];
          //          if(child[j].children && child[j].children.length){
          //           child2=child[j].children;
          //           for(var k=0;k<child2.length;k++){
          //             child2[k].children=null;
          //           }
          //         }
          //        }
          //      }
          //      this.regionCascaders.push(arr[i]) ;
          // }
        });
      },
      changeTab(value){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
        this.teamTab=value;
        this.queryParams.reportType=(value=='Region'?1:2);
      },
      changeHandler(value){
        this.search();
        if(value=='Channel'){
          this.showBack=false;
          this.chartTitle="";
        }
        if(value=='Region'&&this.curRegion.RegionId) this.showBack=true;
      },
      onSelectedMonth(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedRole(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedChannel(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
      onSelectedRegion(){
        this.showBack=false;
        this.curParentRegion={};
        this.curRegion={};
        this.search();
      },
       goBack(){
        //this.regionIds=[];
        if(this.queryParams.reportType==1) this.curParentRegion=this.curRegion.RegionName?this.curParentRegion:{};
        if(this.queryParams.reportType==2){
          if(this.curRegion.RegionName==null){
            if(this.curParentRegion.RegionName.indexOf('-')>-1){
              this.curParentRegion.RegionName=this.curParentRegion.RegionName.split('-')[0];
            }else{
              this.curParentRegion={};
            }

          } 
        } 
        this.curRegion={};
        this.chartTitle="";
        this.search();
        
        if(this.curParentRegion.RegionName==null) this.showBack=false;
      },
      toTop(){
        let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
        if(document.documentElement.scrollTop>0) document.documentElement.scrollTop=0;
        if(document.body.scrollTop>0) document.body.scrollTop=0;
        if(window.pageYOffset>0) window.pageYOffset=0;
      },
      search(){
        this.loadings.chartLoading=true;
        this.queryParams.reportType=this.teamTab=='Region'? 1:2;
        this.queryParams.channelId=this.queryParams.channelId?this.queryParams.channelId:'';
        var m=new Date(this.queryParams.sMonth);
         this.queryParams.sDate=m.getFullYear().toString()+'-'+((m.getMonth()+1)<10?('0'+(m.getMonth()+1).toString()):(m.getMonth()+1).toString()) +'-01';
        this.queryParams.sWhere = this.curRegion.RegionName? (this.curParentRegion.RegionName+'-'+this.curRegion.RegionName): this.curParentRegion.RegionName;
        this.queryParams.regionId=this.regionIds.length>0?this.regionIds[this.regionIds.length - 1]:'';
        //this.queryParams.channelId=this.channelIds.join(',');

        console.log(this.queryParams);

        GetToTerminalReport(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          //console.log(res.data.Data.datatable);
          this.targetDatas.visitNum=res.data.Data[0].datatable[0].VisitNum;
          this.targetDatas.userNum=res.data.Data[0].datatable[0].UserNum;
          this.targetDatas.avgNum=res.data.Data[0].datatable[0].AvgNum;
          this.tableDatas=res.data.Data[1].datatable;
          //this.kpiDatas=res.data.Data[2].datatable;
          //this.getKpiGroup(this.kpiDatas);
          this.splitData();
          this.initChart();
          this.loadings.chartLoading=false;
          //this.queryParams.sDate=moment().format("YYYY-MM-DD");
        }
        );
        this.loadings.kpiLoading=true;
        GetToTerminalReport_KPI(this.queryParams).then(res=>{
          if(res.data.Code!=1) return;
          this.kpiDatas=res.data.Data.datatable;
          this.getKpiGroup(this.kpiDatas);
          this.loadings.kpiLoading=false;
          //this.queryParams.sDate=moment().format("YYYY-MM-DD");
        }
        );

        //console.log(this.queryParams);
        
      },
      splitData(){
        this.seriesData=this.ChartData_Series(this.tableDatas);
        //console.log(this.tableDatas);
        this.dimensionsData=this.ChartData_Dimensions(this.tableDatas);

      },
      getKpiGroup(obj){
        this.kpiGroups=[];
        this.kpiGroups.push(obj[0].GroupName);
        var sGroupName=obj[0].GroupName;
        for(var i=0;i<obj.length;i++){ 
              if(obj[i].GroupName!==sGroupName){
                this.kpiGroups.push(obj[i].GroupName);
                sGroupName=obj[i].GroupName;
              }
          }
      },
      ChartData_Series(){
        var newArr=[];
        var Obj={};
          Obj={
                type:'bar',
                stack:'vistors',
                barWidth:'90%',
                label:{
                    normal: {
                        show: true,
                        position: 'inside'//显示在中间。insideRight
                    }
                  },
                animationDuration:2800,
                animationEasing:'cubicInOut'
                };
        var firstObj={};
        firstObj=this.tableDatas[0];
        for(var x in firstObj){
          if(x!='product')
          newArr.push(Obj);
        }
        return newArr;
      },
      
      ChartData_Dimensions(){//第一列必须是product
        var newArr=['product'];
        var firstObj={};
        firstObj=this.tableDatas[0];
        for(var x in firstObj){
          if(x!='product')
          newArr.push(x);
        }
        return newArr;
      },
      initChart(){
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('main'));
        let that=this;
        // 指定图表的配置项和数据
        var option = {
            title: {
                //text: 'aaa',
                text:this.chartTitle,
                textStyle:{
                    //文字颜色
                    color:'#000000',
                    //字体风格,'normal','italic','oblique'
                    fontStyle:'normal',
                    //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
                    fontWeight:'bold',
                    //字体系列
                    fontFamily:'sans-serif',
                    //字体大小
            　　　　 fontSize:10,
                    
                },
                left:'center'
            },
            //tooltip: {},
            legend: {
                //data:['expected','actual']
                //data:this.legendData,
                bottom:-2
            },
            dataset: {
                // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                //dimensions: ['product', '2015', '2016', '2017'],
                dimensions: this.dimensionsData,
                source: this.tableDatas
            },
            xAxis: {
              //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              //data:this.xAxisData,
              type: 'category',
              //boundaryGap: false,X轴从0开始
              axisTick: {
                //show: false
                alignWithLabel: true//X轴下面加点
              },
              axisLabel : {//坐标轴刻度标签的相关设置。
                interval:0  //每隔都显示；1每隔1个显示
                ,rotate:"45"
            }
            },
            grid: {
              left: 0,
              right: 0,
              bottom: 50,
              top: 50,
              containLabel: true
            },
            tooltip: {
              trigger: 'axis',
              //axisPointer: {
              //  type: 'cross'
              //},//去掉点击后出现的横向虚线
            //   formatter: function (val) {
            //     return val + '%';
            // },
              padding: [5, 10]
            },
            yAxis: {
              axisTick: {
                show: false
              },
              axisLabel: {
                formatter: function (val) {
                    return val;
                }
              },
            },
            dataZoom: [
                // {   // 这个dataZoom组件，默认控制x轴。
                //     type: 'slider', // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                //     start: 0,      // 左边在 10% 的位置。
                //     end: 100         // 右边在 60% 的位置。
                // },
                {   // 这个dataZoom组件，也控制x轴。
                    type: 'inside', // 这个 dataZoom 组件是 inside 型 dataZoom 组件
                    start: 0,      // 左边在 10% 的位置。
                    end: 100         // 右边在 60% 的位置。
                }
            ],
            series:this.seriesData
            
        };

        // 使用刚指定的配置项和数据显示图表。
        //console.log(option);
        myChart.clear();
        myChart.setOption(option);
      myChart.off('click');
        

        //if(this.queryParams.reportType==1){//区域钻取
        var touchtime = new Date().getTime();
            myChart.on('click',function(object){
              if( new Date().getTime() - touchtime > 500 ){
                  touchtime = new Date().getTime();
              }else{
                //if (that.queryParams.reportType==2) return;//渠道维度不钻取
                if (that.curRegion.RegionName!=null) {
                  //that.$router.push({path:"/KPIList/"+that.queryParams.userId});
                  return;//总部维度只钻取一层
                }
                  that.showBack=true;
                  var newtableDatas=[];
                    var downParams=that.queryParams;
                    //var curRegion={};
                    if(that.curParentRegion.RegionName==null){
                          that.curParentRegion.RegionName=object.name;
                    }
                    else if(that.queryParams.reportType==2&& that.curParentRegion.RegionName.indexOf('-')==-1){
                        that.curParentRegion.RegionName=that.curParentRegion.RegionName+'-'+object.name;
                    }
                    else{
                           that.curRegion.RegionName=object.name;
                    }
                    if(that.curParentRegion.RegionName||that.curRegion.RegionName){
                      that.loadings.chartLoading=true;
                      downParams.sWhere=that.curRegion.RegionName? (that.curParentRegion.RegionName+'-'+that.curRegion.RegionName): that.curParentRegion.RegionName;
                      console.log(downParams);
                          GetToTerminalReport(downParams).then(res=>{
                            if(res.data.Code!=1) return;
                            option.dataset.source=res.data.Data[1].datatable;
                            that.targetDatas.visitNum=res.data.Data[0].datatable[0].VisitNum;
                            that.targetDatas.userNum=res.data.Data[0].datatable[0].UserNum;
                            that.targetDatas.avgNum=res.data.Data[0].datatable[0].AvgNum;
                            myChart.setOption(option,true);
                            that.loadings.chartLoading=false;
                          }
                          );

                          that.loadings.kpiLoading=true;
                          GetToTerminalReport_KPI(downParams).then(res=>{
                            if(res.data.Code!=1) return;
                            that.kpiDatas=res.data.Data.datatable;
                            that.getKpiGroup(that.kpiDatas);
                            that.loadings.kpiLoading=false;
                            //this.queryParams.sDate=moment().format("YYYY-MM-DD");
                          }
                          );
                    }
              }
              });
        //}
            

      },
    }
  };
  </script>
  
  <style scoped>
  @import "../../assets/css/kpi/kpi.css";
  </style>

  <style>
      .customWidth {
   min-width:320px;
}

      </style>


// WEBPACK FOOTER //
// src/components/kpi/ToTerminal.vue